module.exports = __webpack_public_path__ + "img/coming-soon.740269d3.jpg";